<template>
  <div>
    <div
      class="d-flex justify-center align-center"
      v-if="isLoading"
      style="min-height: 600px"
    >
      <v-progress-circular indeterminate :size="70" :width="7" color="purple" />
    </div>
    <template v-else>
      <GChart :type="type" :data="chartData" :options="options"
    /></template>
  </div>
</template>

<script>
  import { GChart } from 'vue-google-charts/legacy'
  import { mapActions } from 'vuex'
  export default {
    components: {
      GChart
    },
    props: {
      startDate: {
        type: String
      },
      endDate: {
        type: String
      }
    },
    data() {
      return {
        isLoading: true,
        type: 'PieChart',
        options: {
          colors: ['blue', 'orange', 'green', 'pink', 'red', 'grey'],
          title: 'Sales (subtotal)',
          height: 600,
          animation: { startup: true, duration: 500 },
          legend: { position: 'bottom' }
        }
      }
    },
    computed: {
      consultationsSystemsSubtotal() {
        return this.$store.state.analytics.consultationsSystemsSubtotal
      },
      chartData() {
        return [
          ['Status', 'Count'],
          ['MicroLines', this.consultationsSystemsSubtotal?.['microlines']],
          ['Laserbeamer', this.consultationsSystemsSubtotal?.['laserbeamer']],
          ['FreeStyler', this.consultationsSystemsSubtotal?.['freestyler']],
          ['Bonded', this.consultationsSystemsSubtotal?.['bonded']],
          ['Tape-Ins', this.consultationsSystemsSubtotal?.['tapes']],
          ['Extensions', this.consultationsSystemsSubtotal?.['extensions']]
        ]
      }
    },
    methods: {
      ...mapActions(['fetchConsultationsSystemsSubtotal'])
    },
    watch: {
      async startDate(newValue, oldValue) {
        this.isLoading = true

        await this.fetchConsultationsSystemsSubtotal({
          startDate: this.startDate,
          endDate: this.endDate
        })
        this.isLoading = false
      },
      async endDate(newValue, oldValue) {
        this.isLoading = true

        await this.fetchConsultationsSystemsSubtotal({
          startDate: this.startDate,
          endDate: this.endDate
        })
        this.isLoading = false
      }
    },
    async created() {
      await this.fetchConsultationsSystemsSubtotal({
        startDate: this.startDate,
        endDate: this.endDate
      })
      this.isLoading = false
    }
  }
</script>

<style lang="scss" scoped></style>
